/**
 * @generated SignedSource<<34c43c1c231f34afd5a16179bf451f64>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type composerQueriesExtensionFieldsQuery$variables = Record<PropertyKey, never>;
export type composerQueriesExtensionFieldsQuery$data = {
  readonly extensionFields: ReadonlyArray<{
    readonly dataTypeID: number;
    readonly dataTypeName: string | null;
    readonly fieldID: number | null;
    readonly formatString: string | null;
    readonly id: string;
    readonly label: string | null;
    readonly name: string | null;
    readonly operationTypeID: number;
    readonly operationTypeName: string | null;
  } | null> | null;
};
export type composerQueriesExtensionFieldsQuery = {
  response: composerQueriesExtensionFieldsQuery$data;
  variables: composerQueriesExtensionFieldsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ExtensionField",
    "kind": "LinkedField",
    "name": "extensionFields",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fieldID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "label",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "formatString",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dataTypeID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dataTypeName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "operationTypeID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "operationTypeName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "composerQueriesExtensionFieldsQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "composerQueriesExtensionFieldsQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "103d27edce4faf7b44f42db7e1f9c5f8",
    "id": null,
    "metadata": {},
    "name": "composerQueriesExtensionFieldsQuery",
    "operationKind": "query",
    "text": "query composerQueriesExtensionFieldsQuery {\n  extensionFields {\n    id\n    fieldID\n    name\n    label\n    formatString\n    dataTypeID\n    dataTypeName\n    operationTypeID\n    operationTypeName\n  }\n}\n"
  }
};
})();

(node as any).hash = "b0932c1e4811a24abf61ac73cf9d300d";

export default node;
